export default "__VITE_ASSET__0880770b__"